import { Location } from '@fcom/core-api';
import { isNotBlank, isString, LocalDate } from '@fcom/core/utils';

import { SearchState } from '../interfaces';

export const isStringWithValue = (searchInput: string | Location | null): boolean =>
  isString(searchInput) && isNotBlank(searchInput);

export const getEarliestSearchDayInMonth = ({ year, month }: SearchState['selectedMonth']): LocalDate => {
  const today = LocalDate.now();
  const day = LocalDate.forDate(year, month, 1);

  return LocalDate.forDate(day.toDate().getFullYear(), day.localMonth, day.lt(today) ? today.localDay : 1);
};

export const getLastDayInMonth = ({ year, month }: SearchState['selectedMonth']): LocalDate => {
  return LocalDate.forDateObj(new Date(year, month, 0));
};

export const getCurrentDateIfSearchIsBeforeToday = (
  search: SearchState
):
  | {
      year: number;
      month: number;
      day: LocalDate;
    }
  | undefined => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const { year, month } = search.selectedMonth;

  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return {
      year: currentYear,
      month: currentMonth,
      day: LocalDate.now(),
    };
  }
};

export const normalizeLocalDate = (rawDate: string | LocalDate): LocalDate => {
  return typeof rawDate === 'string' ? (LocalDate.isLocalDate(rawDate) ? new LocalDate(rawDate) : undefined) : rawDate;
};
